import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal,
} from '@angular/core';
import { TransactionWrapper, Upsell } from '@core/models';
import { TransactionService } from '@core/services/transaction.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryComponent {
  upsellSelected = input.required<Upsell | null>();
  transactionService = inject(TransactionService);
  rainoutValue = input.required<boolean>();
  totalTransactionSeats = input.required<number>();
  transaction = input.required<TransactionWrapper>();
  isTicketFeeEnabled = input.required<boolean>();
  isProduction = signal(environment.production);

  get serviceChargesDetails() {
    return this.transactionService.getServiceChargesDetails(
      this.transaction().transaction.tdcTransaction!
    );
  }
}
